<template>
  <svg 
    xmlns="http://www.w3.org/2000/svg" 
    viewBox="0 0 19 19" 
    :fill="iconDisabled ? '#C4C4C4' : fill"
  >
    <path d="M1.39324 10.9256L7.34499 2.62062L6.86352 0.533778C5.85332 0.534683 4.95058 0.887033 4.16039 1.58533C3.29371 2.33862 2.74362 3.37177 2.5101 4.68476L1.39834 10.9256L1.39324 10.9256ZM15.7525 13.2637L18.0115 0.507314L14.0778 0.510837C12.69 0.512081 11.5729 0.716316 10.7314 1.12903C9.78794 1.58578 8.9162 2.37753 8.13148 3.48779L8.07543 3.57023C7.96843 3.72412 7.86143 3.88351 7.75953 4.04839L7.73402 4.04841L0.905839 13.5956L0.0275982 18.5234L0.823513 18.5227C1.84392 18.5218 2.66515 18.3014 3.28212 17.8724C3.91948 17.4324 4.51067 16.7123 5.0557 15.7231L7.78082 10.7331C8.02532 10.2825 8.26981 9.83188 8.51431 9.38125C8.7588 8.93062 9.0033 8.47999 9.24779 8.02936C9.54836 7.52375 9.83879 7.09505 10.1242 6.72677C10.4045 6.3585 10.6848 6.06164 10.9652 5.83069C11.7198 5.22031 12.6634 4.91186 13.7909 4.91085L13.532 6.35021C12.7106 6.35094 12.0883 6.55473 11.6601 6.95609C11.2319 7.35745 10.8293 7.89611 10.4473 8.57757C10.2537 8.91829 10.0652 9.25353 9.89204 9.58325C9.71886 9.91298 9.55079 10.2427 9.38273 10.5779L5.34844 17.865L5.23167 18.5133L9.798 18.5092C11.5327 18.5076 12.8792 18.0835 13.8275 17.2422C14.7757 16.401 15.4123 15.0656 15.7372 13.2472"/>
  </svg>
</template>

<script>
export default {
  name: "icon-mishnat",
  props: {
    iconDisabled: {
      type: Boolean,
      default: false,
    },
    fill: {
      type: String,
      default: '#0F595F',
    }
  }
}
</script>

<style>

</style>


